import React, { useState } from 'react'
import { Container } from '@material-ui/core'
import { useTranslation } from "react-i18next"
import { Grid } from "@material-ui/core"
import { Fragment } from 'react'
import DescriptionTemplatePure from '../description-template/description-template.pure'
import { Button } from '@progress/kendo-react-buttons'
import './message.css'


/**
 * @param {*} props
 * @return {*} 
 * @status no delete
 */
function MessagePure(props) {
    const { t } = useTranslation()
    const [cellNumber, setCellNumber] = useState(false)

    const CODE_LENGTH = new Array(6).fill(0)

    const { validationCode, focused } = props
    const validationCodes = validationCode.split("")

    const hideInput = !(validationCodes.length < CODE_LENGTH.length)

    const selectedIndex = (validationCodes.length < CODE_LENGTH.length) ? validationCodes.length : CODE_LENGTH.length - 1

    return (
        <Fragment>
            <Container className='message-display-flex' spacing={6} lg={12} md={12} sm={6} xs={12} >
                <Grid container className=' message-display-block message-container ' spacing={4}>
                    <DescriptionTemplatePure description={t('messagePure.description')} />
                    <div className="message-pure-email">
                        <p>{props.email}</p>
                    </div>
                    <Grid className='message-container-code'>
                        <div className="message-wrap" onClick={props.handleClick}>
                            <input
                                autoFocus
                                value=""
                                ref={props.input}
                                onFocus={props.handleFocus}
                                onBlur={props.handleBlur}
                                onChange={props.handleChange}
                                onKeyUp={props.handleKeyUp}
                                className="message-input"
                                style={{
                                    width: "32px",
                                    top: "0px",
                                    bottom: "0px",
                                    left: `${selectedIndex * 32}px`,
                                    opacity: hideInput ? 0 : 1,
                                }}
                            />
                            {CODE_LENGTH.map((v, index) => {
                                // return <div className="display">{validationCodes[index]}</div>
                                const selected = validationCodes.length === index
                                const filled =
                                    validationCodes.length === CODE_LENGTH.length && index === CODE_LENGTH.length - 1

                                return (
                                    <div className="message-display">
                                        {validationCodes[index]}
                                        {(selected || filled) && focused && <div className="message-shadows" />}
                                    </div>
                                )
                            })}
                        </div>
                        <Button
                            // type={'submit'}
                            // primary={true}
                            style={{ marginLeft: '15px' }}
                            className='message-button-accept-user'
                            onClick={(e) => props.onReSendMessage(e)}
                            name='message'
                        >
                            {t('messagePure.resendCode')}
                        </Button>
                    </Grid>
                </Grid>
            </Container>
        </Fragment >
    )
}

export { MessagePure as default }
